var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 1.34315 1.34315 0 3 0H5C6.65685 0 8 1.34315 8 3V5C8 6.65685 6.65685 8 5 8H3C1.34315 8 0 6.65685 0 5V3Z",
    fill: "#FF0000",
    fillOpacity: 0.13
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.42365 2.09555C5.56418 2.22827 5.57051 2.44979 5.43779 2.59032L2.60446 5.59032C2.47173 5.73085 2.25021 5.73718 2.10968 5.60446C1.96915 5.47173 1.96282 5.25021 2.09555 5.10968L4.92888 2.10968C5.0616 1.96915 5.28312 1.96282 5.42365 2.09555Z",
    fill: "#F51010"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.10955 2.09555C1.96902 2.22827 1.96269 2.44979 2.09541 2.59032L4.92875 5.59032C5.06147 5.73085 5.28299 5.73718 5.42352 5.60446C5.56405 5.47173 5.57038 5.25021 5.43766 5.10968L2.60432 2.10968C2.4716 1.96915 2.25008 1.96282 2.10955 2.09555Z",
    fill: "#F51010"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.d4447e62bb280941987ee76ad74d4a61.svg";
export { ForwardRef as ReactComponent };